/**
 * Pauses background video in the inactive breakpoint when desktop and mobile use different sources.
 */
if (!customElements.get('responsive-split-bg-video')) {
  class ResponsiveSplitBgVideo extends HTMLElement {
    connectedCallback() {
      this.mql = window.matchMedia('(min-width: 768px)');
      this._onChange = () => this.syncPause();
      if (this.mql.addEventListener) {
        this.mql.addEventListener('change', this._onChange);
      } else if (this.mql.addListener) {
        this.mql.addListener(this._onChange);
      }
      this.syncPause();
    }

    disconnectedCallback() {
      if (!this.mql || !this._onChange) return;
      if (this.mql.removeEventListener) {
        this.mql.removeEventListener('change', this._onChange);
      } else if (this.mql.removeListener) {
        this.mql.removeListener(this._onChange);
      }
    }

    syncPause() {
      const desktopActive = this.mql.matches;
      const desktopSlot = this.querySelector('[data-bg-split="desktop"]');
      const mobileSlot = this.querySelector('[data-bg-split="mobile"]');
      [desktopSlot, mobileSlot].forEach((slot) => {
        if (!slot) return;
        const isDesktopSlot = slot.getAttribute('data-bg-split') === 'desktop';
        const active = isDesktopSlot ? desktopActive : !desktopActive;
        if (active) return;
        const vc = slot.querySelector('video-component');
        if (vc && typeof vc.pause === 'function') {
          vc.pause();
        }
      });
    }
  }

  customElements.define('responsive-split-bg-video', ResponsiveSplitBgVideo);
}
